import { Skeleton } from 'antd';
import styled from 'styled-components';

export const LoaderWrapper = styled.div<{ isExtraSmallScreen?: boolean }>`
  padding-top: ${({ isExtraSmallScreen }) => (isExtraSmallScreen ? '16px' : '32px')};
`;

export const StyledSkeleton = styled(Skeleton)<{ isExtraSmallScreen?: boolean }>`
  padding-top: ${({ isExtraSmallScreen }) => (isExtraSmallScreen ? '16px' : '32px')};
`;
